export default __webpack_public_path__ + "static/lil-nadas-title-3ad2afbfe1cefc8e9728dbdf6d71cf72.gif";